import { useTheme } from "@mui/material/styles";
import { Box, IconButton, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import { useNavigate } from "react-router-dom";
import { CHATAREA } from "../Routes/constURL";

const Logo = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const isMobile = useMediaQuery(theme.breakpoints?.down("sm"));
    const isIpad = useMediaQuery(theme.breakpoints?.down("lg"));
    return (
        <Box sx={{ ml: {xs:2.5,md:1.5},mb:{xs:0,md:2}, display: "flex", maxHeight: "200px", position: "relative", mt: { xs: "10px", md: '20px' } }}>
            <IconButton sx={{
                maxHeight: "61px", "&:hover": {
                    backgroundColor: "inherit"
                },
                "&.MuiIconButton-root":{
                    textAlign:"Start"
                }
            }} onClick={() => navigate(CHATAREA)}>
                <img width={isMobile ? "150px" : "250px"} height={isMobile ? "70px" : "100px"} src={require("../assets/Logo.Worx.png")} alt="w-logo" />
                {/* <Box
                    sx={{
                        ml: 2,
                        mt: {xs:3,md:5},
                        mb: { xs: 1, md: 3 },
                    }}>
                    <Typography sx={{
                        color: "#343568",
                        fontSize: { xs: "16px", md: "24px" },
                        fontWeight: 700,
                    }}>WORX</Typography>
                    <Typography sx={{
                        color: "#343568",
                        fontSize: { xs: "14px", md: "22px" },
                        fontWeight: 600,
                    }}>AI Assistant</Typography>
                </Box> */}
            </IconButton>
        </Box>)
}

export default Logo